<template>
  <div class="idea-challenges">
    <PreContentHeader :show-loading="!contentReady" :error-message="contentLoadError"></PreContentHeader>
    <transition name="fade">
      <div v-if="contentReady && contentLoadError === ''">
        <!--<ContentHeader :name="award.title.rendered"></ContentHeader>-->
        <ContentHeader name="EMPLOYEE RECOGNITION"></ContentHeader>
        <section>
          <div class="card mb-3">
            <div v-if="award._embedded['wp:featuredmedia'] !== undefined" class="featuredImg">
              <img v-if="award._embedded['wp:featuredmedia'][0].media_details.sizes.full.source_url"
                :src="award._embedded['wp:featuredmedia'][0].media_details.sizes.full.source_url"
                :alt="award._embedded['wp:featuredmedia'][0].alt_text"
                :title="award._embedded['wp:featuredmedia'][0].title.rendered"
              >
            </div>
            <div v-html="award.content.rendered" class="card-body px-3 pb-0"></div>
            <div v-if="award.nomination_event_time_frame.length > 0">
              <ul class="fa-ul" v-if="award.nomination_event_time_frame[0][0][0].nomination_event_date_from !== ''">
                <li class="h6">
                  <span class="fa-li"><i class="fas fa-calendar-alt fa-fw fa-sm text-black-50"></i></span>
                  {{award.nomination_event_time_frame[0][0][0].nomination_event_date_from}} -
                  {{award.nomination_event_time_frame[0][0][0].nomination_event_date_to}}
                </li>
              </ul>
            </div>
            <div v-if="madeNomination" class="px-3 pb-3">
              <div class="alert alert-success" role="alert">
                Congratulations, you've nominated:
                <ul>
                  <li v-for="teams in NominationTeamNames" v-bind:key="teams.email">
                    <strong>{{teams.name}}</strong> from {{teams.country}} -
                    Employee number: <strong>{{teams.employeeNum}}</strong><br>
                    Department: <strong>{{teams.department}}</strong><br>
                    Company: <strong>{{teams.company}}</strong><br>
                  </li>
                </ul>
              </div>
              <button type="button" name="button" class="btn btn-primary" v-on:click="removeNominee()">Nominate someone else</button>
            </div>
            <div v-if="award.include_nomination_form[0] === 'Yes' && award.nomination_fields.length > 0 && !madeNomination" class="px-3 pb-3">
              <h4 class="mb-3">{{NominationLabel}}</h4>
              <form v-on:submit.prevent=""><!-- Added OnSubmit; after few plugins update issues -->
                <div class="col-12">
                  <input type="checkbox" name="isMonetary" ref="isMonetary" id="isMonetary" v-on:click="setMonetaryField()"/>
                  <label> Planning for a Monetary Nomination</label>
                </div>
                <div class="input-group input-group-lg mb-4">
                  <vue-bootstrap-typeahead class="form-control" v-model="nominatedPerson" :data="nomineesList" @keydown.enter="search" :serializer="item => item.email" placeholder="Search by email address" prepend="" ></vue-bootstrap-typeahead>
                  <!-- <input type="text" class="form-control" :placeholder="NominationPlaceholder" v-model="nominatedPerson" required> -->
                  <div class="input-group-append">
                    <button class="btn btn-primary" type="submit" :disabled="nominatedPerson.length === 0" v-on:click="setNominee()">{{NominationButtonText}}</button>
                  </div>
                </div>
              </form>
              <PreContentHeader :show-loading="searchingForEmployee" :error-message="searchingForEmployeeError"></PreContentHeader>
              <div class="p-3 mb-2 bg-primary text-white border border-primary font-weight-bold mt-1" v-if="NominationTeamNames.length === 1">Continue to add names if you would like to complete a team nomination for High5 or Teams</div>
              <transition name="grow">
                <div v-if="showNominationForm || NominationTeamNames.length > 0">
                  <hr>
                  <strong>You are nominating:</strong><br>
                  <div v-if="isTeamAwards">
                    <ul>
                      <li v-for="teams in NominationTeamNames" v-bind:key="teams.email">
                        <strong>{{teams.name}}</strong> from {{teams.country}} -
                        Employee number: <strong>{{teams.employeeNum}}</strong><br>
                        Department: <strong>{{teams.department}}</strong><br>
                        Company: <strong>{{teams.company}}</strong><br>
                        <button type="button" class="btn btn-link p-0" v-on:click="removeTeamNominee(teams)">X Remove</button>
                      </li>
                    </ul>
                  </div>
                  <hr>
                  <form v-on:submit.prevent=""><!-- Added OnSubmit; after few plugins update issues -->
                    <div v-for="formField in nominationFields" v-bind:key="formField.index">
                      <NominationField
                        :type="formField.type"
                        :description="formField.description"
                        :secondary-description="formField.secondaryDescription"
                        :description-lvl-two="formField.description_lvl_two"
                        :secondary-description-lvl-two="formField.secondary_description_lvl_two"
                        :is-required="formField.isRequired"
                        :checkbox-labels="formField.checkboxLabels"
                        v-on:updatedFieldContent="fieldUpdated($event)"
                        :validationMethod="formField.validationMethod"
                        :displayField="formField.display_field"
                        :error-class="formField.errorClass">
                      </NominationField>
                    </div>
                    <div class="row py-1">
                      <div class="col offset-md-4 offset-lg-4 offset-xl-3">
                        <div class="form-group form-check">
                          <input type="checkbox" class="form-check-input" id="terms" v-model="termsCheckbox" required>
                          <label for="terms" class="form-check-label">Nomination Complete. I accept the 
                            <router-link to="/page/multichoice-recognition-terms-and-conditions" target="_blank">Terms &amp; Conditions</router-link>
                          </label>
                        </div>
                      </div>
                    </div>
                    <div class="row pt-2 mb-4">
                      <div class="col offset-md-4 offset-lg-4 offset-xl-3" v-if="submitClicked">
                        <button @click="submitNomination" type="submit" class="btn btn-primary btn-lg">Submit Nomination</button>
                      </div>
                    </div>
                  </form>
                </div>
              </transition>
              <PreContentHeader :show-loading="creatingNomination" :error-message="createNominationError"></PreContentHeader>
            </div>
          </div>
        </section>
        <div v-if="award.additional_content.length > 0 && award.additional_content[0] !== '' && award.additional_content !== ''" class="card mb-3">
          <div class="card-body" v-html="award.additional_content[0]"></div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import ContentHeader from '@/components/ContentHeader'
import WordpressRestAPI from '@/helpers/WordpressRestAPI.js'
import WordpressRestURI from '@/helpers/WordpressRestURI.js'
import ADauthentication from '@/helpers/ADauthentication.js'
import NominationNotification from '@/helpers/NominationNotification.js'
import NominationField from '@/components/NominationField'
import Loading from '@/components/Loading'
import PreContentHeader from '@/components/PreContentHeader'
import vueBootstrapTypeahead from 'vue-bootstrap-typeahead'
export default {
  data () {
    return {
      award: [],
      errors: [],
      contentReady: false,
      contentLoadError: '',
      nominationContent: [],
      nominationFields: [],
      nominatedPerson: '',
      madeNomination: false,
      termsCheckbox: false,
      validatedNominee: '',
      showNominationForm: false,
      creatingNomination: false,
      createNominationError: '',
      searchingForEmployee: false,
      searchingForEmployeeError: '',
      isContractorErrorSet: true,
      isTeamAwards: false,
      submitClicked: true,
      NominationButtonText: 'Nominate',
      NominationLabel: 'Nominate an Employee for this Award',
      NominationPlaceholder: 'Search by name and surname or email address...',
      NominationTeamNames: [],
      NominationTeamsContent: [],
      nomineesList: [],
      employeeHierarchy: {},
      awardFields: [{name: 'individual', fields: 'FieldCheckBoxesBehaviours, Field150Word, FieldFileInput'}, {name: 'team', fields: 'FieldCheckBoxesBehaviours, Field150Word, FieldFileInput, FieldSingleText'}]
    }
  },
  components: {
    PreContentHeader,
    ContentHeader,
    NominationField,
    Loading,
    vueBootstrapTypeahead
  },
  methods: {
    setValidatedNominee: function (userData) {
      if (this.checkForDuplicateNominee(userData)) {
        let tempEmail = ''  
        if (userData.UPN && userData.UPN !== null && userData.UPN !== '') {
          tempEmail = userData.UPN
        } else {
          tempEmail = userData.email
        } 
        this.validatedNominee = {
          name: userData.firstname + ' ' + userData.lastname,
          slug: userData.email.replace(/\./g, '-').replace(/@/g, '').toLowerCase(),
          department: userData.department,
          company: (userData.company === '') ? 'Multichoice' : userData.company,
          employeeNum: userData.employeenumber,
          country: userData.country,
          email: tempEmail,
          lineManagerName: (!userData.managername) ? userData.employeehierarchy['line-manager-name'][0] : userData.managername,
          lineManagerEmail: (!userData.manageremail) ? userData.employeehierarchy['line-manager-email'][0] : userData.manageremail,
          employeeHierarchy: userData.employeehierarchy
        }
        this.NominationTeamNames.push(this.validatedNominee)
        this.getPageLabel()
        // this.checkForDuplicateNomination()
        this.setNominationContent(this.award.nomination_fields[0][0])
      }
    },
    getPageLabel: function() {
      if (this.$refs.isMonetary) {
        if (this.$refs.isMonetary.checked) {
          if (this.NominationTeamNames.length > 1) 
            this.NominationLabel = "Team"
          else
            this.NominationLabel = "On the Spot"
        }
        else if (this.NominationTeamNames.length > 1)
          this.NominationLabel = "Team High5"
        else 
          this.NominationLabel = "High5"
      }
    },
    searchLocalDB: function () {
      this.searchingForEmployeeError = ''
      WordpressRestAPI.getLocalDbUserLookup(this.nominatedPerson.toLowerCase())
        .then(response => {
        if (this.checkForDuplicateNominee(response.data))
          this.setValidatedNominee(response.data)
          if (this.$store.getters.getUserEmail.toLowerCase() === response.data.email.toLowerCase()) {
            this.showNominationForm = false
            this.searchingForEmployee = false
            alert('You can\'t nominate yourself. Please nominate one of your colleagues instead.')
            this.searchingForEmployeeError = 'You can\'t nominate yourself. Please nominate one of your colleagues instead.'
          } else {
            this.showNominationForm = true
            this.searchingForEmployee = false
            // this.validateContractors()
          }
        })
        .catch(e => {
          if (this.isContractorErrorSet) {
            this.searchingForEmployee = false
            this.searchingForEmployeeError = 'We could not find a user with the names: ' + this.nominatedPerson + '. Make sure you entered the correct name and surname or try searching by email'
          }
          this.isContractorErrorSet = true
          console.error(e)
        })
    },
    searchByEmail: function () {
      this.searchingForEmployeeError = ''
      ADauthentication.getUserInfoByEmail(this.nominatedPerson)
        .then(response => {
          console.log(response.data)
          this.setValidatedNominee(response.data)
          this.showNominationForm = true
          this.searchingForEmployee = false
          // this.validateContractors()
        })
        .catch(e => {
          if (this.isContractorErrorSet) {
            this.searchingForEmployee = false
            this.searchingForEmployeeError = 'We could not find a user with the email: ' + this.nominatedPerson + '. Make sure you entered the correct email address or try searching by name and surname'
          }
          this.isContractorErrorSet = true
          console.error(e)
        })
    },
    searchByUsername: function () {
      this.searchingForEmployeeError = ''
      ADauthentication.getUserInfoByUsername(this.nominatedPerson.replace(' ', '.').toLowerCase())
        .then(response => {
          console.log(response.data)
          this.setValidatedNominee(response.data)
          if (this.$store.getters.getUserEmail.toLowerCase() === response.data.email.toLowerCase()) {
            this.showNominationForm = false
            this.searchingForEmployee = false
            alert('You can\'t nominate yourself. Please nominate one of your colleagues instead.')
            this.searchingForEmployeeError = 'You can\'t nominate yourself. Please nominate one of your colleagues instead.'
          } else {
            this.showNominationForm = true
            this.searchingForEmployee = false
            // this.validateContractors()
          }
        })
        .catch(e => {
          if (this.isContractorErrorSet) {
            this.searchingForEmployee = false
            this.searchingForEmployeeError = 'We could not find a user with the names: ' + this.nominatedPerson + '. Make sure you entered the correct name and surname or try searching by email'
          }
          this.isContractorErrorSet = true
          console.error(e)
        })
    },
    validateContractors: function () {
      if (this.$route.params.name !== 'employee-of-the-year-2018') {
        if (this.validatedNominee.employeeNum === 0 || this.validatedNominee.employeeNum === '0') {
          this.isContractorErrorSet = false
          this.showNominationForm = false
          this.searchingForEmployee = false
          this.searchingForEmployeeError = 'User names: ' + this.nominatedPerson + ' is a contractor and could not be nominated'
          throw new TypeError(this.searchingForEmployeeError)
        }
      }
    },
    setMonetaryField() {
      if (this.$refs.isMonetary.checked) {
          var count = 0
          var match = false
          var self = this
          var userEmail = ''
          this.NominationTeamNames.forEach(function(item) {
            //console.log('setMonetaryField item ', item); // Access each item in the array
            if (item.employeeHierarchy.ishod[0] === 'Yes') {
              userEmail = userEmail+" "+item.email 
              match = true
              count++
            }
          })
          if (match) {
            if (count === 1) {
              alert(`User ${userEmail}, is a HOD and therefore cannot be nominated for a monetary benefit, please remove this user, after the user is removed a monetary nomination can be created.`)
            }
            if (count > 1) {
              alert(`Users ${userEmail} are HOD and therefore cannot be nominated for a monetary benefit, please remove these users, after these users are removed a monetary nomination can be created.`)              
            }
            self.$refs.isMonetary.checked = !self.$refs.isMonetary.checked
            return false;
          }
        }
      if ( this.validatedNominee.name ) {
        if ( confirm("Moving to monetary nomination will reset the behaviour. \n Please confirm.") === true ) {
          this.setNominationContent(this.award.nomination_fields[0][0])
        }
        else {
          this.$refs.isMonetary.checked = !this.$refs.isMonetary.checked
        }
      }
      this.getPageLabel()
    },
    checkForDuplicateNominee: function(data) {
      var self = this
      var dupliEmail = []
      if (self.NominationTeamNames.length > 0) {
        dupliEmail = self.NominationTeamNames.filter(d => d.email.toLowerCase() ===  data.email.toLowerCase() || d.name.toLowerCase() === data.firstname.toLowerCase() + ' ' + data.lastname.toLowerCase())
      }
      if (self.$store.getters.getUserEmail.toLowerCase() === data.email.toLowerCase() || self.$store.getters.getUserName.toLowerCase() === data.firstname.toLowerCase() + ' ' + data.lastname.toLowerCase()) {
        dupliEmail.push(data.email)
        self.searchingForEmployeeError = 'You can\'t nominate yourself. Please nominate one of your colleagues instead.'
        return false
      }
      if (dupliEmail.length > 0) {
        self.searchingForEmployeeError = 'Duplicate Nominee ' + data.email
        return false
      }
      /*if (data.employeehierarchy) {
        if (data.employeehierarchy.ishod[0] ===  'Yes') {
          self.searchingForEmployeeError = 'SELECTED NOMINEE '  + data.email + ' IS HOD (OR ABOVE) AND CANNOT BE NOMINATED'
          return false
        }
      }*/
      if (data.employeehierarchy) {
                if (this.$refs.isMonetary.checked) {  
                    console.log(' monetary checked ', data.employeehierarchy.ishod[0])
                    if (data.employeehierarchy.ishod[0] ===  'Yes') {
                        self.searchingForEmployeeError = 'SELECTED NOMINEE '  + data.email + ' IS HOD (OR ABOVE) AND CANNOT BE NOMINATED'
                        return false
                    }
                }
      }
      else if (data.employeehierarchy === false) {
        self.searchingForEmployeeError = 'Nominee ' + data.email + ' is not present in Think Tank list. For further assistance, Please contact thinktank@multichoice.co.za'
        return false
      }
      return true
    },
    setNominee: function () {
      this.searchingForEmployee = true
      this.searchingForEmployeeError = ''
      if (this.isTeamAwards) {
        if (this.nominatedPerson.split(',').length > 50) {
          this.searchingForEmployee = false
          this.searchingForEmployeeError = 'Team Member count can\'t exceed 50!'
        }
        var self = this
        if (this.searchingForEmployee) {
          this.nominatedPerson.split(',').map(function (val, index) {
            let valOrg = val.trim()
            val = val.trim().toLowerCase()
            console.log('NominationTeamNames ', self.NominationTeamNames)
            var dupEmail = self.NominationTeamNames.filter(d => d.email.toLowerCase() === val)
            var dupName = 0
            if (val.indexOf('@') > -1) {
              dupName = self.NominationTeamNames.filter(d => d.name.toLowerCase() === val)
            }
            if (dupEmail.length > 0 || dupName > 0) {
              alert('Duplicate Nominee ' + val)
              self.searchingForEmployee = false
            } else if (val !== '') {
              if (val.toLowerCase().indexOf('irdeto') > -1) {
                alert('Irdeto can\'t be nominated for this Awards.')
                self.searchingForEmployeeError = 'Irdeto can\'t be nominated for this Awards'
                self.searchingForEmployee = false
              } else if (self.$store.getters.getUserEmail.toLowerCase() === val.trim().toLowerCase() || self.$store.getters.getUserName.toLowerCase() === val.trim().toLowerCase()) {
                alert('You can\'t nominate yourself.')
                self.searchingForEmployeeError = 'You can\'t nominate yourself'
                self.searchingForEmployee = false
              } else {
                console.log('valOrg', valOrg)
                if (val.indexOf('@') > -1) {
                  ADauthentication.getUserInfoByEmail(valOrg)
                    .then(response => {
                      self.setValidatedNominee(response.data)
                      if (self.NominationTeamNames.length > 1) {
                        self.showNominationForm = true
                      }
                      self.searchingForEmployee = false
                    })
                    .catch(e => {
                      self.searchingForEmployee = false
                      self.searchingForEmployeeError = 'Unable to find the Nominee; Please try again!'
                      console.error(e)
                    })
                } else {
                  ADauthentication.getUserInfoByUsername(val.replace(' ', '.').toLowerCase())
                    .then(response => {
                      console.log(response.data)
                      self.setValidatedNominee(response.data)
                      console.log('NominationTeamNames Length', self.NominationTeamNames.length)
                      if (self.NominationTeamNames.length > 1) {
                        self.showNominationForm = true
                      }
                      self.searchingForEmployee = false
                    })
                    .catch(e => {
                      self.searchingForEmployee = false
                      self.searchingForEmployeeError = 'We could not find a user with the names: ' + val + '. Make sure you entered the correct name and surname or try searching by email'
                      console.error(e)
                    })
                }
              }
            }
          })
        }
      } else
      if (this.nominatedPerson.toLowerCase().indexOf('irdeto') > -1 || this.nominatedPerson.toLowerCase().indexOf('showmax') > -1) {
        if ((this.$route.params.name === 'employee-of-the-year-2018' || this.$route.params.name === 'team-awards-2018') && this.nominatedPerson.toLowerCase().indexOf('showmax') === -1) {
          alert('Irdeto can\'t be nominated for this Awards. Please nominate your colleagues for Innovation Awards.')
          this.searchingForEmployee = false
        } else if (this.$store.getters.getUserEmail.toLowerCase() !== this.nominatedPerson.toLowerCase()) {
          this.searchLocalDB()
        } else {
          alert('You can\'t nominate yourself. Please nominate one of your colleagues instead.')
          this.searchingForEmployee = false
        }
      } else if (this.nominatedPerson.indexOf('@') > -1) {
        if (this.$store.getters.getUserEmail.toLowerCase() !== this.nominatedPerson.toLowerCase()) {
          this.searchByEmail()
        } else {
          alert('You can\'t nominate yourself. Please nominate one of your colleagues instead.')
          this.searchingForEmployee = false
        }
      } else {
        if (this.$store.getters.getUserName.toLowerCase() !== this.nominatedPerson.toLowerCase()) {
          this.searchByUsername()
        } else {
          alert('You can\'t nominate yourself. Please nominate one of your colleagues instead.')
          this.searchingForEmployee = false
        }
      }
    },
    removeNominee: function () {
      this.validatedNominee = {name: '', department: '', employeeNum: ''}
      this.showNominationForm = false
      this.nominatedPerson = ''
      this.madeNomination = false
      this.NominationTeamNames = []
      this.submitClicked = true
    },
    removeTeamNominee: function (index) {
      this.NominationTeamNames.splice(this.NominationTeamNames.indexOf(index), 1)
      if (this.NominationTeamNames.length === 0) {
        this.showNominationForm = false
      }
      this.getPageLabel()
      this.setNominationContent(this.award.nomination_fields[0][0])
    },
    setPostContent: function (type) {
      var content = ''
      var plainContent = ''
      for (var i = 0; i < this.nominationContent.length; i++) {
        if (this.nominationContent[i].displayField)
          if (this.nominationContent[i].label !== 'If applicable, please attach supporting documentation (Word, PowerPoint, video):' && this.nominationContent[i].label !== 'Project Sponsor Email' && this.nominationContent[i].label !== 'Choose Behaviour') {
            content += '<strong>' + this.nominationContent[i].label + '</strong><br><p>' + this.nominationContent[i].content + '</p>'
            plainContent += '<h>' + this.nominationContent[i].label + '<h> @#$% <c>' + this.nominationContent[i].content + '<c> @#$% '
          }
      }
      return (type === 'nohtml' ? plainContent : content)
    },
    ValidateFields: function (value, type, label) {
      if (type.toLowerCase() === 'email') {
        if (value.indexOf('@') === -1 || value.indexOf('.') === -1) {
          alert('Invalid ' + label + ' !')
          return false
        } else if (value.split('@').length > 2) {
          alert ('Only one mail allowed for ' + label + ' !' )
          return false
        }
        return true
      }
    },
    readyToSubmitNomination: function () {
      var contentPassedValidation = true
      this.searchingForEmployeeError = ''
      for (var j = 0; j < this.nominationContent.length; j++) {
        this.nominationFields[j].errorClass = ''
        if (this.nominationFields[j].display_field === false) {
          continue
        } else {
          if (this.nominationFields[j].validationMethod) {
            contentPassedValidation = this.ValidateFields(this.nominationContent[j].content, this.nominationFields[j].validationMethod, this.nominationContent[j].label)
          }
          if (this.nominationContent[j].required === 'false' && this.nominationContent[j].content === '' && !this.nominationContent[j].validated) {
            this.nominationContent[j].validated = true
          }
          if (this.nominationContent[j].validated === false) {
            contentPassedValidation = false
            this.nominationFields[j].errorClass = 'field-not-validated'
          }
          if (this.isTeamAwards) {
            if (this.NominationTeamNames.length > 50) {
              this.searchingForEmployeeError = 'Team Member count can\'t exceeds 50!'
              contentPassedValidation = false
            }
          }
          // Stop immedieatly any field validation is false
          if (contentPassedValidation === false)
            break;
        }
      }
      return this.termsCheckbox && contentPassedValidation
    },
    addMediaToNominationPost: function (mediaID, postID) {
      var sendNomination = {
        method: 'POST',
        data: {
          supporting_documentation: mediaID
        },
        headers: {
          'Authorization': localStorage.getItem('userToken'),
          'Content-Type': 'application/json'
        },
        json: true
      }
      WordpressRestAPI.endpointWithAuthetication(sendNomination, 'nomination/' + postID)
        .then(function (response) {
          console.log(response)
        })
        .catch(function (e) {
          console.error(e)
        })
    },
    uploadSupportingDocumentation: function (postID, supportingDoc) {
      var self = this
      var formData = new FormData()
      formData.append('file', supportingDoc)
      formData.append('title', 'Supporting documentation for ' + self.validatedNominee.name)
      formData.append('caption', 'Supporting documentation for ' + self.validatedNominee.name)
      if (self.isTeamAwards) {
        formData.append('title', 'Supporting documentation for Team by ' + self.$store.getters.getUserName)
        formData.append('caption', 'Supporting documentation for Team by ' + self.$store.getters.getUserName)
      }
      var uploadMedia = {
        method: 'POST',
        processData: false,
        contentType: false,
        data: formData,
        headers: {
          'Authorization': localStorage.getItem('userToken'),
          'Content-Type': 'application/json'
        },
        json: true
      }
      WordpressRestAPI.endpointWithAuthetication(uploadMedia, 'media')
        .then(function (response) {
          console.log(response)
          self.addMediaToNominationPost(response.data.id, postID)
        })
        .catch(function (e) {
          console.error(e)
        })
    },
    checkForMediaUpload: function (postID) {
      var supportingDoc = this.nominationContent.filter(x => {
        return x.label.indexOf('supporting documentation') > -1 && x.content !== ''
      })
      if (supportingDoc.length > 0) {
        this.uploadSupportingDocumentation(postID, supportingDoc[0].content)
      }
    },
    sendEmailNotificationToNominee: function (nominationID) {
      let emailBody = NominationNotification.nominationBodyWithReview({
        nominee: this.validatedNominee.name,
        awardName: this.award.title.rendered,
        prizeMoney: this.award.nomination_award_prize[0],
        reviewLink: WordpressRestURI.frontEndDomain + 'login/my-profile+review-nomination+' + nominationID,
        closingDate: this.award.nomination_event_time_frame[0][0][0].nomination_event_date_to
      })
      var emailNominationNotification = {
        method: 'POST',
        data: {
          to: this.validatedNominee.email,
          subject: 'You have received a nomination on ThinkTank',
          message: emailBody
        },
        json: true
      }

      console.log(emailNominationNotification)

      WordpressRestAPI.sendEmail(emailNominationNotification)
        .then(function (response) {
          console.log(response.data)
        })
        .catch(function (e) {
          console.error(e)
        })
    },
    sendEmailNotificationToNominator: function (nominationID) {
      let emailBody = NominationNotification.confirmationOfNominationBody({
        nominee: this.validatedNominee.name,
        nominator: this.$store.getters.getUserName,
        awardName: this.award.title.rendered,
        prizeMoney: this.award.nomination_award_prize[0],
        reviewLink: WordpressRestURI.frontEndDomain + 'login/my-profile+review-nomination+' + nominationID,
        closingDate: this.award.nomination_event_time_frame[0][0][0].nomination_event_date_to
      })
      var emailNominationNotification = {
        method: 'POST',
        data: {
          to: this.$store.getters.getUserEmail,
          subject: 'You sent a nomination on ThinkTank',
          message: emailBody
        },
        json: true
      }

      WordpressRestAPI.sendEmail(emailNominationNotification)
        .then(function (response) {
          console.log(response.data)
        })
        .catch(function (e) {
          console.error(e)
        })
    },
    sendEmailNotificationToTeam: function (nominationID) {
      for (var i = 0; i < this.NominationTeamNames.length; i++) {
        let emailBody = NominationNotification.teamNominationBodyWithReview({
          nominee: this.NominationTeamNames[i].name,
          awardName: this.award.title.rendered,
          prizeMoney: this.award.nomination_award_prize[0],
          reviewLink: WordpressRestURI.frontEndDomain + 'login/my-profile+review-nomination+' + nominationID,
          closingDate: this.award.nomination_event_time_frame[0][0][0].nomination_event_date_to
        })
        var emailNominationNotification = {
          method: 'POST',
          data: {
            to: this.NominationTeamNames[i].email,
            subject: 'You have received a nomination on ThinkTank',
            message: emailBody
          },
          json: true
        }

        console.log(emailNominationNotification)

        WordpressRestAPI.sendEmail(emailNominationNotification)
          .then(function (response) {
            console.log(response.data)
          })
          .catch(function (e) {
            console.error(e)
          })
      }
    },
    sendEmailNotificationToTeamNominator: function (nominationID) {
      let emailBody = NominationNotification.confirmationOfNominationBody({
        nominator: this.$store.getters.getUserName,
        awardName: this.award.title.rendered,
        prizeMoney: this.award.nomination_award_prize[0],
        reviewLink: WordpressRestURI.frontEndDomain + 'login/my-profile+review-nomination+' + nominationID,
        closingDate: this.award.nomination_event_time_frame[0][0][0].nomination_event_date_to
      })
      var emailNominationNotification = {
        method: 'POST',
        data: {
          to: this.$store.getters.getUserEmail,
          subject: 'You sent a nomination on ThinkTank',
          message: emailBody
        },
        json: true
      }

      WordpressRestAPI.sendEmail(emailNominationNotification)
        .then(function (response) {
          console.log(response.data)
        })
        .catch(function (e) {
          console.error(e)
        })
    },
    setNominationAcceptedecline: function () {
      if (this.award.nomination_event_category.includes(13)) {
        return 'Accepted'
      } else {
        return 'Pending'
      }
    },
    assignUserCommunities: function () {
      return this.award.community_categories.filter(
        f => this.$store.getters.getUserCommunityIDstring.split(',').map(x => parseInt(x)).includes(f)
      )
    },
    getNominationEventCategory: function () {
      var self = this
      var nominationEventCategory = []
      nominationEventCategory.push('20')
      if (self.NominationTeamNames.length === 1 && self.$refs.isMonetary.checked) {
      // On the Spot
        nominationEventCategory.push('103')
      } else if (self.NominationTeamNames.length > 1 && self.$refs.isMonetary.checked) {
      // Teams
        nominationEventCategory.push('104')
      } else {
      // High5
        nominationEventCategory.push('102')
      }
      return nominationEventCategory
    },
    getNominationTitle: function () {
      var self = this
      var nominationTitle = ''
      if (self.NominationTeamNames.length === 1 && self.$refs.isMonetary.checked){
        nominationTitle = self.validatedNominee.name + ', On the Spot'
      }
      else if (self.NominationTeamNames.length > 1 && self.$refs.isMonetary.checked){
        nominationTitle = 'Team Awards, by ' + self.$store.getters.getProfileDetails.name
      }
      else {
        if (self.NominationTeamNames.length === 1)
          nominationTitle = self.validatedNominee.name + ', High5'
        else
          nominationTitle = 'Team High5, by ' + self.$store.getters.getProfileDetails.name
      }
      return nominationTitle
    },
    createNominationEntry: function () {
      this.showNominationForm = false
      this.creatingNomination = true
      var self = this
      var sendNomination = {
        method: 'POST',
        data: {
          title: self.getNominationTitle(),
          nomination_event_category: self.getNominationEventCategory(),
          community_categories: self.assignUserCommunities(),
          nomination_approve_decline: 'Accepted',
          nominee_name: self.validatedNominee.name,
          nominee_slug: self.validatedNominee.slug,
          status: 'publish',
          content: self.setPostContent('html'),
          nominationdata: self.setPostContent('nohtml'),
          nominator_details: [{
            'employee-number': self.validatedNominee.employeeNum,
            'employee-company': self.validatedNominee.department
          }]
        },
        headers: {
          'Authorization': localStorage.getItem('userToken'),
          'Content-Type': 'application/json'
        },
        json: true
      }
      var parentName = ''
      if (self.$refs.isMonetary.checked === false) {
        sendNomination.data.bigups_ecards = []
        sendNomination.data.bigups_ecards.push(self.nominationContent.filter(x => {return x.label.indexOf('Choose Behaviour') > -1 })[0].parentcategory)
        sendNomination.data.bigups_ecards.push(self.nominationContent.filter(x => {return x.label.indexOf('Choose Behaviour') > -1 })[0].content)
        parentName = self.nominationContent.filter(x => {return x.label.indexOf('Choose Behaviour') > -1 })[0].parentName
      }
      // var ehSlug = (self.isTeamAwards) ? self.NominationTeamNames[0].slug : self.validatedNominee.slug
      // WordpressRestAPI.getViewContent('employeehierarchy?slug=' + ehSlug + '&_embed')
        // .then(response => {
          // self.employeeHierarchy = response.data[0]
          self.employeeHierarchy = (self.isTeamAwards) ? self.NominationTeamNames[0].employeeHierarchy : self.validatedNominee.employeeHierarchy
          sendNomination.data.teamnominationworkflow = []
          var d = new Date()
          let nominationDate = d.getFullYear() + '-' + parseInt(parseInt(d.getMonth()) + 1) + '-' + d.getDate() + ' ' + d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds()

          // Push Line Manager
          if (self.NominationTeamNames.length > 1) {
            sendNomination.data.teamnominationworkflow.push({'project_sponsor_name': 'Manager', 'project_sponsor_email': self.NominationTeamNames[0].lineManagerEmail,'project_sponsor_comment': '', 'project_sponsor_status': (self.$refs.isMonetary.checked) ? '' : 'Approve', 'project_sponsor_datetime': (self.$refs.isMonetary.checked) ? '' : nominationDate})
          } else {
            sendNomination.data.teamnominationworkflow.push({'project_sponsor_name': 'Manager', 'project_sponsor_email': self.validatedNominee.lineManagerEmail,'project_sponsor_comment': '', 'project_sponsor_status': (self.$refs.isMonetary.checked) ? '' : 'Approve', 'project_sponsor_datetime': (self.$refs.isMonetary.checked) ? '' : nominationDate})
          }

          // Push Exco2 Manager
          if (self.employeeHierarchy['exco2-email'][0]) {
            sendNomination.data.teamnominationworkflow.push({'project_sponsor_name': 'Exco2', 'project_sponsor_email': self.employeeHierarchy['exco2-email'][0], 'project_sponsor_comment': '', 'project_sponsor_status': (self.$refs.isMonetary.checked) ? '' : 'Approve', 'project_sponsor_datetime': (self.$refs.isMonetary.checked) ? '' : nominationDate})
          }
          // Push HRBP
          if (self.employeeHierarchy['hrbp-email'][0]) {
            sendNomination.data.teamnominationworkflow.push({'project_sponsor_name': 'HRBP', 'project_sponsor_email': self.employeeHierarchy['hrbp-email'][0], 'project_sponsor_comment': '', 'project_sponsor_status': (self.$refs.isMonetary.checked) ? '' : 'Approve', 'project_sponsor_datetime': (self.$refs.isMonetary.checked) ? '' : nominationDate})
          }

          if (self.NominationTeamNames.length > 1) {
            sendNomination.data.nominationteam = []
            sendNomination.data.nominee_name = ''
            sendNomination.data.nominee_slug = ''
            for (var i = 0; i < self.NominationTeamNames.length; i++) {
              sendNomination.data.nominationteam.push({
                'member_name': self.NominationTeamNames[i].name,
                'member_approve_reject': 'Accepted',
                'member_company': self.NominationTeamNames[i].company,
                'member_employee_number': self.NominationTeamNames[i].employeeNum,
                'member_slug': self.NominationTeamNames[i].slug
              })
            }
          }
          if (self.$refs.isMonetary.checked && self.NominationTeamNames.length > 1) {
            sendNomination.data.isteamaward = 'true'
          // Push Project Sponsor
            sendNomination.data.teamnominationworkflow.push({'project_sponsor_name': 'Sponsor', 'project_sponsor_email': self.nominationContent.filter(x => {return x.label.indexOf('Project Sponsor Email') > -1 })[0].content,'project_sponsor_comment': '', 'project_sponsor_status': '', 'project_sponsor_datetime': ''})
            // sendNomination.data.title = self.award.title.rendered + ', by ' + self.$store.getters.getProfileDetails.name
          }
          WordpressRestAPI.endpointWithAuthetication(sendNomination, 'nomination')
            .then(function (response) {
              console.log(response)
              self.checkForMediaUpload(response.data.id)
              if (self.$refs.isMonetary.checked) {
                if (self.NominationTeamNames.length > 1) {
                  // NOTIFY PROJECT SPONSOR
                  self.promoteToReview(response.data, 'sponsor', 'Project Sponsor')
                  // self.sendEmailNotificationToTeam(response.data.id)
                  // self.sendEmailNotificationToTeamNominator(response.data.id)
                }
                else {
                  // NOTIFY LINE MANAGER
                  self.promoteToReview(response.data, 'manager', 'Line Manager')
                  // self.sendEmailNotificationToNominee(response.data.id)
                  // self.sendEmailNotificationToNominator(response.data.id)
                }
              }
              else {
                // HIGH5 Emails notification goes here
                console.log('HIGH5 Notification goes here')
                self.high5Notification(response.data, parentName)
              }
              self.madeNomination = true
              self.creatingNomination = false
            })
            .catch(function (e) {
              self.createNominationError = 'Oops! We had a problem adding your nomination. Please try again later.'
              console.error(e)
            })
        // })
        // .catch(function (f) {
          // self.createNominationError = 'Oops! We had a problem adding your nomination. Please try again later.'
          // console.error(f)
        // })
    },
    high5Notification: function (nominationDetails, parentName) {
      let emailBody = ''
      var tempEmail = []
      var toMail, ccMail, nomineeName = ''
      if (nominationDetails.id) {
        if (this.NominationTeamNames.length > 1) {
          let toMailChunks = this.NominationTeamNames.map(function (name, index) {
            return name.email
          })
          toMail = toMailChunks.join(',')
          let toNameChunks = this.NominationTeamNames.map(function (name, index) {
            return name.name.split(' ')[0]
          })
          nomineeName = toNameChunks.join(',')
          // nomineeName = toNameChunks[0] + ' and Team'
        }
        else {
          nomineeName = this.validatedNominee.name
          toMail = this.validatedNominee.email
        }
        let ccMailChunks = nominationDetails.teamnominationworkflow[0].map(function (name, index) {
          if (name.project_sponsor_name.toLowerCase() !== "exco2")
            return name.project_sponsor_email
        })
        ccMail = ccMailChunks.join(',')
        //TODO: Change the Email template once received
        emailBody = NominationNotification.high5Notification({
          nominee: nomineeName,
          nominator: this.$store.getters.getProfileDetails.name,
          cardName: parentName
        })
        // tempEmail = nominationDetails.teamnominationworkflow[0].filter(d => d.project_sponsor_name.toLowerCase() === reviewer)
            // to: 'deenanath.mishra@nihilent.com',
            // cc: 'deenanath.mishra@multichoice.co.za',
        var emailNominationNotification = {
          method: 'POST',
          data: {
            to: toMail,
            subject: 'You�ve received a High 5!',
            message: emailBody,
            cc: ccMail,
            attachmentId: nominationDetails.id,
            recipient: nomineeName,
          },
          json: true
        }
        WordpressRestAPI.sendEmail(emailNominationNotification)
          .then(function (response) {
            console.log(response.data)
          })
          .catch(function (e) {
            console.error(e)
        })
      }
    },
    promoteToReview: function (nominationDetails, reviewer, reviewerLabel) {
      let emailBody = ''
      var tempEmail = []
      if (nominationDetails.id) {
        // TODO: Change the Email template once received
        emailBody = NominationNotification.nominationBodyProjectSponsorWithReview({
          reviewLink: WordpressRestURI.frontEndDomain + 'login/my-profile+review-manager+' + nominationDetails.id + '+' + reviewer,
          position: reviewerLabel
        })
        tempEmail = nominationDetails.teamnominationworkflow[0].filter(d => d.project_sponsor_name.toLowerCase() === reviewer)
        var emailNominationNotification = {
          method: 'POST',
          data: {
            to: tempEmail[0].project_sponsor_email,
            subject: 'You have been identified as ' + reviewerLabel + ' on ThinkTank',
            message: emailBody
          },
          json: true
        }

        WordpressRestAPI.sendEmail(emailNominationNotification)
          .then(function (response) {
            console.log(response.data)
          })
          .catch(function (e) {
            console.error(e)
          })
      }
    },
    submitNomination: function () {
      this.submitClicked = false
      if (this.readyToSubmitNomination()) {
        this.createNominationEntry()
      } else {
        this.submitClicked = true
      }
    },
    fieldUpdated: function (fieldDetails) {
      for (var i = 0; i < this.nominationContent.length; i++) {
        if (this.nominationContent[i].label === fieldDetails.label) {
          this.nominationContent[i].content = fieldDetails.content
          this.nominationContent[i].validated = fieldDetails.validated
          this.nominationContent[i].displayField = fieldDetails.displayField
          if (fieldDetails.label === 'Choose Behaviour') {
            this.nominationContent[i].parentcategory = fieldDetails.parentcategory
            this.nominationContent[i].parentName = fieldDetails.parentName
          }
          break
        }
      }
    },
    setNominationContent: function (nominationFields) {
      var self = this
      self.nominationFields = nominationFields.map(function (x, index) {
        var displayFieldVal = x.display_field === "No" ? false : true
        var fieldDescriptionVal = x.field_description
        var FieldSecondaryDescriptionVal = x.field_secondary_description
        if (self.$refs.isMonetary) {
          if (self.$refs.isMonetary.checked) {
            var type = self.NominationTeamNames.length
            if (type == 1) {
              displayFieldVal = self.awardFields[0].fields.includes(x.form_field_type)
            }
            else if (type > 1) {
              displayFieldVal = self.awardFields[1].fields.includes(x.form_field_type)
            }
          }
          //Toggle Message/Motivation
          if (fieldDescriptionVal == "Message" && FieldSecondaryDescriptionVal == "Motivation") {
            if (self.$refs.isMonetary.checked) {
              fieldDescriptionVal = FieldSecondaryDescriptionVal
            }
            FieldSecondaryDescriptionVal = ''
          }
        }

        return {
          type: x.form_field_type,
          description: fieldDescriptionVal,
          secondaryDescription: FieldSecondaryDescriptionVal,
          isRequired: x.required_nomination_field,
          checkboxLabels: x.checkbox_labels,
          errorClass: '',
          index: index + x.form_field_type,
          description_lvl_two: x.description_lvl_two,
          secondary_description_lvl_two: x.secondary_description_lvl_two,
          display_field: displayFieldVal,
          validationMethod: x.validationmethod
        }
      })

      if (self.nominationContent.length > 1) {
        self.nominationContent = self.nominationFields.map(function (x, i) {
          return {label: x.description, content: self.nominationContent[i].content, required: x.isRequired, validated: false, displayField: x.displayField}
        })
      } else  {
        self.nominationContent = self.nominationFields.map(function (x) {
          return {label: x.description, content: '', required: x.isRequired, validated: false, displayField: x.displayField}
        })
      }
    },
    loadContent: function () {
      var tempData = '<a href="http://high5.multichoice.com" class="aquacolor font-weight-bold" target="_blank">Click here</a>'
      // var gettersData = this.$store.getters
      // console.log('this ref', this.$store.getters)
      // console.log('getEmail', this.$store.getters.getProfileDetails.email)
      // console.log('getEmail mapping', this.getProfileDetails)
      if (localStorage.getItem('high5Token')) {
        tempData = '<a href="http://high5.multichoice.com?mail_id=' + localStorage.getItem('high5Token') + '" class="aquacolor font-weight-bold" target="_blank">Click here</a>'
      } else if (this.$store.getters.getProfileDetails.email) {
        tempData = '<a href="http://high5.multichoice.com?mail_id=' + btoa(this.$store.getters.getProfileDetails.email.toLowerCase()) + '" class="aquacolor font-weight-bold" target="_blank">Click here</a>'
      }
      this.madeNomination = false
      this.nominatedPerson = ''
      // document.title = this.$route.params.name.replace(/-/g, ' ') + ' - ThinkTank'
      document.title = this.$route.name + ' - ThinkTank'
      // WordpressRestAPI.getViewContent('nomination_event?slug=' + this.$route.params.name + '&_embed')
      WordpressRestAPI.getViewContent('nomination_event?nomination_event_category=22&_embed&per_page=1')
        .then(response => {
          this.award = response.data[0]
          this.award.content.rendered = this.award.content.rendered.replace('<microsite>LINK</microsite>', tempData)
          this.contentReady = true
          if (this.award.include_nomination_form[0] === 'Yes') {
            // Reinitiate every variable related with form
            // this.isTeamAwards = false
            // this.NominationButtonText = 'Nominate'
            // this.NominationLabel = 'Nominate an Employee for this Award'
            // this.NominationPlaceholder = 'Search by name and surname or email address...'
            this.NominationTeamNames = []
            // if (this.award._embedded['wp:term'][1][0].id === 104 || this.award._embedded['wp:term'][0][0].id === 104 || this.award._embedded['wp:term'][0][0].id === 104 || this.award._embedded['wp:term'][0][1].id === 104) {
              this.isTeamAwards = true
              this.NominationButtonText = 'Add Nominee'
              this.NominationLabel = 'High5'
              this.NominationPlaceholder = 'Search by email address, seperate multiple email by comma...'
            // }
            this.setNominationContent(this.award.nomination_fields[0][0])
          }
        })
        .catch(e => {
          this.contentLoadError = 'Oops! We had a problem with loading this Recognition. Please try again later.'
          console.error(e)
          this.contentReady = true
        })
    },
    searchNomineeList: function (newQuery) {
      if ( newQuery.length > 2 )
      WordpressRestAPI.getCustomViewContent('getNominees/v1/nomineelist?search=' + newQuery)
        .then((res) => {
          this.nomineesList = res.data
        })
    }
  },
  created () {
    this.loadContent()
  },
  watch: {
    nominatedPerson (newQuery, oldQuery) { 
      if (newQuery != '')
        this.searchNomineeList(newQuery) 
    },
    '$route' (to, from) {
      this.contentReady = false
      this.loadContent()
    }
  }
}
</script>

<style lang="less">
  .featuredImg {
    img {
      width: 100%;
    }
  }
  .box {.icon { text-align: center; position: relative; }}
  .box { .icon { .image { position: relative; z-index: 2; width: 50px; height: 50px; line-height: 50px; border-radius: 50%; background: #09ced6; vertical-align: middle; }}}
  .box { .icon:hover { .image { background: #63B76C; }}}
  .box { .icon { .image { i { color: #fff !important; border: 1px solid white; padding: 10px; border-radius: 50%; min-width: 38px;}}}}
  .box { .icon { .info { margin-top: -45px; margin-left: 20px; padding: 15px 20px 10px 0px; }}}
  .box { .icon { .infoaqua { background-color:#CEF6F8; }}}
  .box { .icon { .infogrey { background-color:#F8F8F8; }}}
  .box { .icon { .infowhite { background-color:#FFFFFF; }}}
  .box { .icon { .info { h3 { font-weight: 500;  margin: 0 0 0 50px; text-align: left; color: #09ced6; }}}}
  .box { .icon { .info { h5 { font-weight: 500;  margin: 0 0 0 50px; text-align: left; color: #09ced6; }}}}
  .box { .icon { .info { ul {list-style: none; margin-left: 20px;}}}}
  .box { .icon { .info { ul { li::before { content: "\2022"; color: #09ced6; display: inline-block; width: 1em; margin-left: -1em;}}}}}
  .box { .icon { .info { .miniseparator {width: 55px; border-bottom: 5px solid #09ced6; margin-left: 50px;}}}}
  .box { .icon { .info { p {margin-left: 40px;}}}}
  .aquacolor {color:#09ced6;}
  .navycolor {color: navy;}
</style>



// WEBPACK FOOTER //
// src/components/routes/VEAward.vue